var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.516,
    height: 35.5,
    viewBox: "0 0 36.516 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project_master",
    "data-name": "project master",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19946",
    "data-name": "Group 19946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24106",
    "data-name": "Path 24106",
    d: "M161.345,62.936h-1.206a.326.326,0,0,0,0,.652h1.206a.326.326,0,0,0,0-.652Z",
    transform: "translate(-148.18 -60.513)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24107",
    "data-name": "Path 24107",
    d: "M229.775,63.588h4.685a.326.326,0,1,0,0-.652h-4.685a.326.326,0,0,0,0,.652Z",
    transform: "translate(-211.365 -60.513)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24108",
    "data-name": "Path 24108",
    d: "M161.345,105.989h-1.206a.326.326,0,0,0,0,.652h1.206a.326.326,0,0,0,0-.652Z",
    transform: "translate(-148.18 -98.959)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24109",
    "data-name": "Path 24109",
    d: "M229.775,106.641h4.685a.326.326,0,1,0,0-.652h-4.685a.326.326,0,0,0,0,.652Z",
    transform: "translate(-211.365 -98.959)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24110",
    "data-name": "Path 24110",
    d: "M161.345,149.043h-1.206a.326.326,0,1,0,0,.652h1.206a.326.326,0,1,0,0-.652Z",
    transform: "translate(-148.18 -138.948)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24111",
    "data-name": "Path 24111",
    d: "M229.775,149.7h4.685a.326.326,0,1,0,0-.652h-4.685a.326.326,0,1,0,0,.652Z",
    transform: "translate(-211.365 -138.948)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24112",
    "data-name": "Path 24112",
    d: "M166.054,367.207v-1.594a.565.565,0,0,0-.564-.564h-7.439a.564.564,0,0,0-.564.564v1.594a.564.564,0,0,0,.564.564h7.439A.565.565,0,0,0,166.054,367.207Zm-.652-.088h-7.263V365.7H165.4Z",
    transform: "translate(-143.763 -338.495)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24113",
    "data-name": "Path 24113",
    d: "M161.345,192.1h-1.206a.326.326,0,0,0,0,.652h1.206a.326.326,0,0,0,0-.652Z",
    transform: "translate(-148.18 -178.937)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24114",
    "data-name": "Path 24114",
    d: "M229.775,192.748h4.685a.326.326,0,1,0,0-.652h-4.685a.326.326,0,0,0,0,.652Z",
    transform: "translate(-211.365 -178.937)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24115",
    "data-name": "Path 24115",
    d: "M161.345,235.149h-1.206a.326.326,0,1,0,0,.652h1.206a.326.326,0,1,0,0-.652Z",
    transform: "translate(-148.18 -218.925)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24116",
    "data-name": "Path 24116",
    d: "M229.775,235.8h4.685a.326.326,0,1,0,0-.652h-4.685a.326.326,0,1,0,0,.652Z",
    transform: "translate(-211.365 -218.925)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24117",
    "data-name": "Path 24117",
    d: "M191.955,451.807a.326.326,0,0,0,0,.652H196.9a.326.326,0,0,0,0-.652Z",
    transform: "translate(-176.42 -419.11)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24118",
    "data-name": "Path 24118",
    d: "M35.489,27H33.237l1.354-9.171a.528.528,0,0,0-1.044-.154L32.171,27H27.728V10.562L34.3,11.621a.136.136,0,0,1,.09.056.141.141,0,0,1,.023.11l-.555,3.757a.528.528,0,1,0,1.044.154l.554-3.75a1.194,1.194,0,0,0-.989-1.368L27.728,9.493V8.416a1.2,1.2,0,0,0-1.194-1.194H17.325a.528.528,0,1,0,0,1.055h9.209a.139.139,0,0,1,.139.139V27h-2.8a1.612,1.612,0,0,0-1.5,1.043l-.523,1.4a.552.552,0,0,1-.515.357H14.682a.552.552,0,0,1-.515-.357l-.523-1.4A1.612,1.612,0,0,0,12.141,27h-2.8V8.416a.139.139,0,0,1,.139-.139h5.733a.528.528,0,1,0,0-1.055H9.482A1.2,1.2,0,0,0,8.289,8.416V9.493L1.545,10.579a1.194,1.194,0,0,0-.99,1.361L2.779,27H.528A.528.528,0,0,0,0,27.523v9.744a4.96,4.96,0,0,0,4.954,4.954H7.24a.528.528,0,1,0,0-1.055H4.954a3.9,3.9,0,0,1-3.9-3.9V28.051H12.141a.552.552,0,0,1,.515.357l.523,1.4a1.612,1.612,0,0,0,1.5,1.043h6.651a1.612,1.612,0,0,0,1.5-1.043l.523-1.4a.552.552,0,0,1,.515-.357H34.961v9.217a3.9,3.9,0,0,1-3.9,3.9H9.35a.528.528,0,1,0,0,1.055H31.062a4.96,4.96,0,0,0,4.954-4.954V27.523A.528.528,0,0,0,35.489,27ZM1.6,11.78a.139.139,0,0,1,.115-.159l6.576-1.059V27H3.846Z",
    transform: "translate(0 -7.222)",
    fill: "#ebb460",
    stroke: "#ebb460",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldProject);
export default __webpack_public_path__ + "static/media/holdProject.516be7e787792401f71702e76b7278c1.svg";
export { ForwardRef as ReactComponent };